import React from 'react';
import { AuthContextProvider } from './AuthContext';
import { CourseContextProvider } from './CourseContext';
import { UserContextProvider } from './UserContext';
import { NotificationContextProvider } from './NotificationContext';

export const AppContextProvider = (props) => {
  return (
    <AuthContextProvider>
      <UserContextProvider>
        <CourseContextProvider>
          <NotificationContextProvider>
            {props.children}
          </NotificationContextProvider>
        </CourseContextProvider>
      </UserContextProvider>
    </AuthContextProvider>
  );
};
